<template>
    <div :class="[{ 'lb-creation-card': showControls }, cardSizeClass]">
        <div
            ref="card"
            :class="cardSizeClass"
            class="lb-card"
            @mouseover="showToolbar = true"
            @mouseleave="showToolbar = false"
        >
            <div
                v-if="hasAccess && showToolbar"
                class="buttons has-addons toolbar"
            >
                <a
                    v-if="!showControls"
                    class="button is-dark"
                    @click.stop="enableEdition"
                >
                    <span class="icon is-small">
                        <i class="fas fa-edit" />
                    </span>
                </a>
                <a
                    v-if="isEdition || isCreation"
                    class="button is-dark"
                    @click.stop="validateAndSave"
                >
                    <span class="icon is-small">
                        <i class="fas fa-save" />
                    </span>
                </a>
                <a class="button is-dark" @click.stop="$emit('delete')">
                    <span class="icon is-small">
                        <i class="fas fa-trash" />
                    </span>
                </a>
            </div>
            <div @click.stop="$emit('click', $event.target.value)">
                <div class="lb-card-content">
                    <div class="columns px-0 py-0">
                        <div class="column is-6 pr-4 has-border-right">
                            <div class="pb-2">
                                <div class="level is-mobile">
                                    <div class="level-left is-shrinkable">
                                        <div class="level-item is-shrinkable">
                                            <p
                                                class="
                                                    card-header-title
                                                    title
                                                    is-paddingless
                                                    is-size-5
                                                    is-block
                                                "
                                            >
                                                {{
                                                    $t(
                                                        'Object.treasurehunt.clue'
                                                    )
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <input-rich-text
                                v-if="
                                    (showControls && model.description) ||
                                    content.description
                                "
                                v-model="content.description"
                                :editable="showControls"
                            />
                            <object-card-tags
                                v-if="content.tags"
                                :tags="content.tags"
                            />
                            <object-card-media
                                :show-controls="showControls"
                                :location.sync="content.location"
                                :images.sync="content.images"
                                :files.sync="content.files"
                                :embed.sync="content.embed"
                                :audio.sync="content.audio"
                                :video.sync="content.video"
                                :url.sync="content.url"
                                @click="openModalEdit"
                            />
                            <object-card-related
                                v-if="model.related"
                                v-show="isEdition || isCreation || showAnswers"
                                :show-creation="showControls"
                                :answers.sync="content.answers"
                                :answer-type.sync="content.answerType"
                            />
                            <object-card-toolbar
                                v-if="showControls"
                                :options="model.media"
                                :expanded="cardSize == 'LARGE'"
                                @click="openModal"
                            />
                        </div>
                        <div class="column is-6 pl-4">
                            <div class="pb-2">
                                <div class="level is-mobile">
                                    <div class="level-left is-shrinkable">
                                        <div class="level-item is-shrinkable">
                                            <p
                                                class="
                                                    card-header-title
                                                    title
                                                    is-paddingless
                                                    is-size-5
                                                    is-block
                                                "
                                            >
                                                {{
                                                    $t(
                                                        'Object.treasurehunt.goal'
                                                    )
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <object-card-media
                                :location.sync="pointContent.location"
                                @click="
                                    showControls &&
                                        $emit(
                                            'addPoint',
                                            pointContent,
                                            'location'
                                        )
                                "
                            />
                            <div
                                v-if="!pointContent.location"
                                class="control has-text-centered pt-6"
                            >
                                <button
                                    class="button lb-button is-primary"
                                    @click="
                                        $emit(
                                            'addPoint',
                                            pointContent,
                                            'location'
                                        )
                                    "
                                >
                                    {{ $t('Object.treasurehunt.add_location') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="!showControls"
                        class="level is-mobile mb-0 pt-0"
                        @click.stop
                    >
                        <div
                            :class="{ 'has-cursor-pointer': isLoggedIn }"
                            class="level-left"
                        >
                            <div
                                v-if="$store.getters.canLikeObjects"
                                :class="{ 'has-text-primary': content.liked }"
                                class="level-item"
                                @click="toggleLike"
                            >
                                <p class="has-text-weight-bold">
                                    {{ content.likes || 0 }}
                                </p>
                                <span class="icon is-medium">
                                    <i
                                        class="mdi mdi-18px mdi-thumb-up"
                                        aria-hidden="true"
                                    ></i>
                                </span>
                            </div>
                        </div>

                        <div class="level-right">
                            <div class="level-item">
                                <div
                                    class="
                                        dropdown
                                        is-right is-hoverable is-pulled-right
                                    "
                                >
                                    <span
                                        class="
                                            icon
                                            is-small
                                            dropdown-trigger
                                            has-text-grey
                                        "
                                    >
                                        <i
                                            class="
                                                mdi mdi-24px mdi-dots-vertical
                                            "
                                            aria-hidden="true"
                                        />
                                    </span>
                                    <div class="dropdown-menu" role="menu">
                                        <div class="dropdown-content">
                                            <div class="dropdown-item">
                                                <a
                                                    v-t="'Object.share'"
                                                    @click="
                                                        showShareModal = true
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <object-card-comments
                        v-if="!showControls && canAddComment"
                        :comments="content.comments"
                        :object="content"
                        @loadOldComments="$emit('click')"
                    />
                </div>
            </div>

            <project-modal-share
                v-if="showShareModal"
                :content="content"
                @close="showShareModal = false"
            ></project-modal-share>
        </div>
    </div>
</template>

<script>
import ObjectCardToolbar from '@/components/ObjectCardToolbar';
import ObjectCardRelatedToolbar from '@/components/ObjectCardRelatedToolbar';
import ObjectCardMedia from '@/components/ObjectCardMedia';
import ObjectCardRelated from '@/components/ObjectCardRelated';
import ObjectCardTags from '@/components/ObjectCardTags';
import ObjectCardComments from '@/components/ObjectCardComments';
import AppCollapsableText from '@/components/AppCollapsableText';
import vClickOutside from 'v-click-outside';
import InputRichText from '@/components/InputRichText';
import _ from 'underscore';
import { likeObject } from '@/services/API';
import ProjectModalShare from '@/components/ProjectModalShare';
import { fetchItem } from '@/services/API';
export default {
    name: 'ObjectCardClue',
    components: {
        ObjectCardToolbar,
        ObjectCardMedia,
        ObjectCardRelated,
        ObjectCardRelatedToolbar,
        ObjectCardTags,
        ObjectCardComments,
        InputRichText,
        AppCollapsableText,
        ProjectModalShare,
    },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
        isCreation: { type: Boolean, default: false },
        isEdition: { type: Boolean, default: false },
        modalOpened: { type: Boolean, default: false },
        showAnswers: {
            type: Boolean,
            default: false,
        },
        hasLocation: {
            type: Boolean,
            default: false,
        },
        resetPoint: {
            type: String,
            default: undefined,
        },
    },
    data() {
        return {
            showToolbar: false,
            showEdition: false,
            showShareModal: false,
            resizeObserver: new ResizeObserver((entries) => {
                for (let entry of entries) {
                    this.$emit('resize');
                }
            }),
            pointModel: this.$store.getters.goalModel,
            model: this.$store.getters.clueModel,
            pointContent: {},
        };
    },
    computed: {
        contentURL() {
            return window.location.href;
        },
        relatedContent: {
            get() {
                const relatedObjects = _.pluck(this.model.related, 'name');
                return _.pick(this.content, relatedObjects);
            },
            set() {
                console.log('here set related content');
            },
        },
        mediaContent() {
            const mediaObjects = _.pluck(this.model.media, 'name');
            return _.pick(this.content, mediaObjects);
        },
        hasAccess() {
            if (this.isCreation) {
                return true;
            }
            return this.content.accessLevel == 'administrator';
        },
        showControls() {
            return this.isEdition || this.isCreation;
        },
        cardSize() {
            return this.$store.getters['Project/cardSize'];
        },
        cardSizeClass() {
            return `is-${this.cardSize.toLowerCase()}`;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        canAddComment() {
            if (this.isLoggedIn && this.$store.getters.canCommentInObjects) {
                return true;
            }
            return false;
        },
    },
    mounted() {
        this.resizeObserver.observe(this.$refs.card);
        if (this.hasLocation && this.isCreation && !this.content.location) {
            this.$emit('addElement', 'location');
        }
        if (this.content._id && this.content._id != 'draft') {
            // console.log('clue triggers', this.content.triggers.GO_TO_POINT);
            /*fetchItem('object', this.content.triggers.GO_TO_POINT).then(
                ({ data }) => {
                    this.pointContent = data;
                }
            );*/

            this.pointContent = _.findWhere(
                this.$store.getters.projectContent,
                {
                    _id: this.content.triggers.GO_TO_POINT,
                }
            );
        }
    },
    destroyed() {
        this.resizeObserver.disconnect();
    },
    methods: {
        enableEdition() {
            this.$emit('edit');
            this.showEdition = true;
        },
        /* onClickOutside(e) {
            if (!this.modalOpened) {
                if (_.isEmpty(this.content.description)) {
                    console.log('canceling');
                    return this.$emit('cancel');
                }
                if (this.showControls) {
                    e.type != 'touchstart' && this.$emit('clickOutside');
                }
            }
        },*/
        openModal(e) {
            this.$emit('addElement', e.type);
        },
        openModalEdit(e) {
            this.showControls && this.$emit('addElement', e);
        },
        async toggleLike() {
            if (this.isLoggedIn) {
                let likeResult = await likeObject(this.content._id);
                this.content.liked = likeResult.data.liked;
                this.content.likes = likeResult.data.likes;
            }
        },
        validateAndSave() {
            // validating clue
            // console.log(this.model);
            const requiredMedia = _.chain(this.model.media)
                .filter((media) => media.required)
                .pluck('name')
                .concat()
                .value();
            const requiredProps = _.chain(this.model)
                .pick((value, key) => {
                    return value.required;
                })
                .keys()
                .value();
            const requiredFields = requiredProps.concat(requiredMedia);
            const isValid = _.chain(requiredFields)
                .every((prop) => _.has(this.content, prop))
                .value();
            if (isValid) {
                // console.log('clue validation success');
                // validating point
                const requiredPointMedia = _.chain(this.pointModel.media)
                    .filter((media) => media.required)
                    .pluck('name')
                    .concat()
                    .value();
                const isPointValid = _.chain(requiredPointMedia)
                    .every((prop) => _.has(this.pointContent, prop))
                    .value();
                if (isPointValid) {
                    // console.log('point validation success');
                    this.$emit('save', this.pointContent);
                } else {
                    alert(this.$t('Error.MISSING_REQUIRED_LOCATION'));
                }
            } else {
                alert(this.$t('Error.MISSING_REQUIRED_CLUE_FIELDS'));
            }
        },
    },
    watch: {
        resetPoint: {
            handler(pointId) {
                // console.log('reseting point', pointId);
                if (pointId == this.pointContent._id) {
                    this.pointContent = _.findWhere(
                        this.$store.getters.projectContent,
                        {
                            _id: this.content.triggers.GO_TO_POINT,
                        }
                    );
                    this.$emit('goalreseted');
                }
            },
        },
    },
};
</script>

<style scoped>
.toolbar {
    position: absolute;
    top: -10px;
    right: 10px;
    z-index: 2;
}

.lb-card-text {
    padding-top: 0;
}

.card-header-title {
    overflow-wrap: break-word;
    padding: 0 1rem;
}

.card-header-title.input {
    padding: 0;
}
.card-header-title.input {
    border-color: none;
}
.card-header-title.input:focus {
    border-color: none;
}
.card-header-title.input:active {
    border-color: none;
}

textarea {
    min-height: 80px;
    resize: vertical;
}
.lb-card-content > * + * {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
/deep/ .ProseMirror {
    min-height: unset;
}
.has-border-right {
    border-right: 1px solid #f1f1f1;
}
</style>
